module.exports = __webpack_public_path__ + "img/loading.047c3372.png";